// @flow

import  { type CheckoutReceipts } from './types';
import { getInstalmentsFromReceipts } from './get-instalments';
import { getSafeInstalmentsPlan } from './receipt';

export function getLowerInstalmentKey(receipts: CheckoutReceipts): string {
  const instalments = getInstalmentsFromReceipts(receipts)
    .map(instalment => getSafeInstalmentsPlan(instalment).instalments);

  return Math.min(...instalments)
    .toString();
}
